// extracted by mini-css-extract-plugin
export default {"AdSlotOffsite":"bgs_a bhr_bi"};